module.exports = __webpack_public_path__ + "img/st-cb6-1-100.2aa63c94.gif";